import React from 'react'
import AdminHeader from '../../../Components/AdminComponent/AdminHeader/AdminHeader'
import AdminSidebar from '../../../Components/AdminComponent/AdminSidebar/AdminSidebar'
import AddRewardsComponent from '../../../Components/AdminComponent/AddRewardsComponent/AddRewardsComponent'

const AddRewards = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
    <AdminHeader />
    <div className='row col-lg-12'>
        <AdminSidebar />
        <div className='col-lg-10 right_content'>
            <AddRewardsComponent/>

        </div>
    </div>
</div>
  )
}

export default AddRewards
